import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/copilotCTA.css';

const CopilotCTA = () => {
    const navigate = useNavigate();

    return (
        <section className="cta-section">
            <div className="cta-container">
                <div className="cta-content">
                    <h2 className="cta-heading">Start Your Copilot Journey with Synectiks</h2>
                    <p className="cta-subheading">
                        Ready to implement Copilot with confidence? 
                        Let Synectiks guide your organization through secure readiness, 
                        structured deployment, and lasting adoption.
                    </p>
                    
                    <h3 className="cta-action-title">Schedule a Copilot Integration Assessment</h3>
                    
                    <div className="cta-button-group">
                        <button 
                            className="btn-primary-cta" 
                            onClick={() => navigate('/company/contact')}
                        >
                              Request a Readiness Workshop
                        </button>
                        
                        {/* <button 
                            className="btn-secondary-cta" 
                            onClick={() => navigate('/contact/workshop')}
                        >
                            Request a Readiness Workshop
                        </button> */}
                    </div>
                </div>
            </div>
            
            <div className="cta-bg-glow"></div>
        </section>
    );
};

export default CopilotCTA;